import PropTypes from 'prop-types';
import React from 'react';
import { getYoutubeVideoId } from '../../../components/Video/YouTube/get-youtube-video-id';
import styles from '../../../components/Video/Video.module.scss';
const YouTube = ({ externalUrl }) => {
    const videoId = getYoutubeVideoId(externalUrl);
    if (!videoId)
        return null;
    return (React.createElement("div", { className: styles.ratioOuter },
        React.createElement("iframe", { allow: "fullscreen; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, className: styles.ratioInner, frameBorder: "0", src: `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`, title: "Waitrose YouTube Video" })));
};
YouTube.displayName = 'YouTube';
YouTube.defaultProps = {
    externalUrl: null,
};
YouTube.propTypes = {
    externalUrl: PropTypes.string,
};
export default YouTube;
//# sourceMappingURL=YouTube.js.map